import i18next, {i18n} from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-http-backend';
import {injectable} from "inversify";

@injectable()
export class I18nService {
    private i18n: i18n;
    constructor() {
        this.i18n = i18next
            .use(Backend)
            .use(initReactI18next);
    }

    public init(): Promise<i18n> {
        return this.i18n.init({
            lng: 'tr',
            fallbackLng: 'tr',
            debug: true,
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            }
        }).then(() => (this.i18n));
    }

}
